// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__HmNrU","file":"styles_file__22SpE"};